import Configs from '../Configs';
import I18n from '../i18n';
import Utils from './Utils';

/**
 * @returns Utils
 */
export const createInstance = (configsInstance, i18nInstance) => (
  new Utils(configsInstance, i18nInstance)
);

const instance = new Utils(Configs, I18n);

export default instance;



// WEBPACK FOOTER //
// ./src/Utils/index.js